import { render } from "./ContentControls.vue?vue&type=template&id=654223b7"
import script from "./ContentControls.vue?vue&type=script&lang=js"
export * from "./ContentControls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__